export enum ContentTreeContainerDisplayMode {
    Block = 'block',
    Flex = 'flex',
    Grid = 'grid'
}
